import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {NavbarComponent} from '../components/navbar/navbar.component';
import {NgIf} from '@angular/common';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatIcon} from '@angular/material/icon';
import {MatPaginator, MatPaginatorIntl} from '@angular/material/paginator';
import {ClientService} from '../services/client.service';
import {DatePipe} from '../pipe/date.pipe';
import {getFrenchPaginatorIntl} from '../translators/mat-paginator-intl-fr';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {AddClientDialogComponent} from '../components/add-client-dialog/add-client-dialog.component';

export interface Client {
  id: number;
  id_nrj: number;
  name: string;
  powerbi_link: string;
  created_at: string;
}

@Component({
  selector: 'app-clients-list',
  imports: [
    MatProgressSpinner,
    NavbarComponent,
    NgIf,
    MatTableModule,
    MatIcon,
    MatPaginator,
    MatProgressSpinner,
    ReactiveFormsModule,
    FormsModule,
    DatePipe,
    MatDialogModule
  ],
  providers: [ClientService, { provide: MatPaginatorIntl, useValue: getFrenchPaginatorIntl() }],
  templateUrl: './clients-list.component.html',
  styleUrl: './clients-list.component.css'
})

export class ClientsListComponent implements AfterViewInit, OnInit {
  public isLoading = false;

  displayedColumns: string[] = ['name', 'link', 'date', 'edit'];
  dataSource = new MatTableDataSource<Client>([]);
  private filtredClients: Client[] = [];
  private currentClients: Client[] = [];

  constructor(
    private clientService: ClientService,
    private dialog: MatDialog
  ) {
  }

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  searchString: any;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  updateSearchString($event: any) {
    if (this.searchString.length >= 1) {
      const searchLower = this.searchString.toLowerCase();
      this.filtredClients = this.currentClients.filter((client) => {
        return client.name.toLowerCase().includes(searchLower);
      });
      this.dataSource.data = this.filtredClients;
    } else {
      this.dataSource.data = this.currentClients;
    }
  }

  openAddClientDialog(nrj_id: string, powerBILink: string) {
    const dialogRef = this.dialog.open(AddClientDialogComponent, {
      width: '400px',
      panelClass: 'my-dialog-bg',
      data: {
        powerBILink: powerBILink,
        nrj_id: nrj_id
      }
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.clientService.getAll().subscribe({
      next: data => {

        this.currentClients = data;
        this.dataSource.data = data;
        this.isLoading = false;
      },
      error: error => {
        console.log(error);
        this.isLoading = false;
      }
    })
  }
}
